import { useState, createContext } from "react";
import { useDispatch } from "react-redux";
import { isEmpty } from "lodash";

import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../../redux/actions/loadingActions/loadingActions";
import {
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";
import {
  createGeoAdminService,
  deleteGeoAdminService,
  editGeoAdminService,
} from "../../../services/adminServices";
import { getGeoService } from "./../../../services/publicServices";

export const geoAdminContext = createContext({
  provinces: [],
  setProvinces: () => {},
  cities: [],
  setCities: () => {},
  geo: {},
  setGeo: () => {},
  id: "",
  setId: () => {},
  isShowModal: null,
  setIsShowModal: () => {},
  handleShowModal: () => {},
  handleHideModal: () => {},
  handleGetGeo: () => {},
  handleCreateGeo: () => {},
  handleEditGeo: () => {},
  handleDeleteGeo: () => {},
});

const GeoAdminContext = ({ children }) => {
  const dispatch = useDispatch();

  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);
  const [geo, setGeo] = useState({});
  const [id, setId] = useState("");
  const [isShowModal, setIsShowModal] = useState(false);

  // Modal Operation
  const handleShowModal = (val, setValue) => {
    setIsShowModal(true);

    if (val) {
      setId(val._id);
      setValue("name", val.name);
    }
  };
  const handleHideModal = () => {
    setIsShowModal(false);
    setId("");
  };

  // Get Geo
  const handleGetGeo = async (item) => {
    const province = item ?? geo;
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getGeoService({
        provinceId: province?._id,
      });
      if (status === 200) {
        if (isEmpty(province)) setProvinces(data.result?.geo);
        else {
          setCities(data.result?.geo);
          setGeo(province);
        }
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Create Geo
  const handleCreateGeo = async (userData) => {
    const objData = {
      provinceId: geo?._id,
      ...userData,
    };
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await createGeoAdminService(objData);
      if (status === 200) {
        toastSuccessMessage(data.resultMessage);
        handleGetGeo();
        handleHideModal();
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Edit Geo
  const handleEditGeo = async (userData) => {
    const objData = {
      id,
      ...userData,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await editGeoAdminService(objData);
      if (status === 200) {
        toastSuccessMessage(data.resultMessage);
        handleGetGeo();
        handleHideModal();
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Delete Geo
  const handleDeleteGeo = async (id) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await deleteGeoAdminService(id);
      if (status === 200) {
        toastSuccessMessage(data.resultMessage);
        handleGetGeo();
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <geoAdminContext.Provider
      value={{
        provinces,
        setProvinces,
        cities,
        setCities,
        geo,
        setGeo,
        id,
        setId,
        isShowModal,
        setIsShowModal,
        handleShowModal,
        handleHideModal,
        handleGetGeo,
        handleCreateGeo,
        handleEditGeo,
        handleDeleteGeo,
      }}
    >
      {children}
    </geoAdminContext.Provider>
  );
};

export default GeoAdminContext;
